import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import ProtectedRoute from 'commons/protected-route'
import ROUTING_PATH from 'constants/route'
import Action from 'pages/action'
import ContractList from 'pages/contract'
import AtHomeDetail from 'pages/contract/athome'
import ChatPannel from 'pages/contract/chat'
import ContractDetail from 'pages/contract/detail'
import ForgotPassword from 'pages/forgot-password'
import Home from 'pages/home'
import AgentLogin from 'pages/login/agent'
import OwnerLogin from 'pages/login/owner'
import NotFound from 'pages/not-found'
import EmailSetting from 'pages/setting/email'
import EmailSettingDone from './pages/setting/email-done'
import PasswordSetting from 'pages/setting/passwrod'
import SuumoDetail from 'pages/contract/suumo'
import ComparableSales from './pages/contract/comparable-sales'
import NotificationSetting from './pages/setting/notification'
import AuthenticationSetting from 'pages/setting/authentication'
import Other from './pages/contract/other'
import SignInLink from './pages/signinlink/signinlink'
import ActiveInventories from './pages/contract/active-inventories'
import ActiveInventoriesMap from './pages/contract/active-inventories-map'
import SuccessfullyConcludedDeals from 'pages/contract/successfully-concluded-deals'
import SuccessfullyConcludedDealsMap from 'pages/contract/successfully-concluded-deals-map'

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* 共通 */}
        <Route
          path={ROUTING_PATH.A0101}
          element={<Navigate to={ROUTING_PATH.B0101} />}
        />
        <Route path="*" element={<NotFound />} />
        {/* 売り主向け */}
        <Route path={ROUTING_PATH.B0101} element={<OwnerLogin />} />
        <Route path={ROUTING_PATH.B0102} element={<ForgotPassword />} />
        <Route path={ROUTING_PATH.B0103} element={<Action />} />
        <Route path={ROUTING_PATH.OwnerSignInLink} element={<SignInLink />} />
        <Route
          path={ROUTING_PATH.B0201}
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0301}
          element={
            <ProtectedRoute>
              <ContractList />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0302}
          element={
            <ProtectedRoute>
              <ContractDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0303}
          element={
            <ProtectedRoute>
              <ChatPannel />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0304}
          element={
            <ProtectedRoute>
              <SuumoDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0305}
          element={
            <ProtectedRoute>
              <AtHomeDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0311}
          element={
            <ProtectedRoute>
              <ComparableSales />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0401}
          element={
            <ProtectedRoute>
              <EmailSetting />
            </ProtectedRoute>
          }
        />
        <Route path={ROUTING_PATH.B0402} element={<EmailSettingDone />} />
        <Route
          path={ROUTING_PATH.B0403}
          element={
            <ProtectedRoute>
              <PasswordSetting />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0404}
          element={
            <ProtectedRoute>
              <NotificationSetting />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.B0405}
          element={
            <ProtectedRoute>
              <AuthenticationSetting />
            </ProtectedRoute>
          }
        />

        <Route
          path={ROUTING_PATH.OwnerContractOther}
          element={
            <ProtectedRoute>
              <Other />
            </ProtectedRoute>
          }
        />

        <Route
          path={ROUTING_PATH.OwnerActiveInventories}
          element={
            <ProtectedRoute>
              <ActiveInventories />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.OwnerActiveInventoriesMap}
          element={
            <ProtectedRoute>
              <ActiveInventoriesMap />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.OwnerSuccessfullyConcludedDeals}
          element={
            <ProtectedRoute>
              <SuccessfullyConcludedDeals />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.OwnerSuccessfullyConcludedDealsMap}
          element={
            <ProtectedRoute>
              <SuccessfullyConcludedDealsMap />
            </ProtectedRoute>
          }
        />

        {/* エージェント向け */}
        <Route path={ROUTING_PATH.C0101} element={<AgentLogin />} />
        <Route
          path={ROUTING_PATH.C0201}
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.C0301}
          element={
            <ProtectedRoute>
              <ContractList />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.C0302}
          element={
            <ProtectedRoute>
              <ContractDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.C0303}
          element={
            <ProtectedRoute>
              <ChatPannel />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.C0304}
          element={
            <ProtectedRoute>
              <SuumoDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.C0305}
          element={
            <ProtectedRoute>
              <AtHomeDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.C0311}
          element={
            <ProtectedRoute>
              <ComparableSales />
            </ProtectedRoute>
          }
        />

        <Route
          path={ROUTING_PATH.AgentContractOther}
          element={
            <ProtectedRoute>
              <Other />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.AgentActiveInventories}
          element={
            <ProtectedRoute>
              <ActiveInventories />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.AgentActiveInventoriesMap}
          element={
            <ProtectedRoute>
              <ActiveInventoriesMap />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.AgentSuccessfullyConcludedDeals}
          element={
            <ProtectedRoute>
              <SuccessfullyConcludedDeals />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTING_PATH.AgentSuccessfullyConcludedDealsMap}
          element={
            <ProtectedRoute>
              <SuccessfullyConcludedDealsMap />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
